/**
 * #2439: a full page load, for when this tab's in-memory identity is no
 * longer the browser's (see `auth-sync.ts`). `null` reloads the current
 * path; a path loads that path instead. Its own module so suites can replace
 * it: jsdom cannot navigate.
 */
export function hardReload(to: string | null): void {
  if (typeof window === 'undefined') return;
  try {
    if (to === null) window.location.reload();
    else window.location.assign(to);
  } catch {
    // A sandboxed frame may refuse to navigate; nothing else to do.
  }
}
